//===============================================================================================================
// #1 - Import * Colors
//===============================================================================================================
import { colors as color } from "./colors";

//===============================================================================================================
// #2 - Import * Font Weight
//===============================================================================================================
import { fontWeight } from "./font-weight";

//===============================================================================================================
// #3 - Import * Mixins => { Media Queries }
//===============================================================================================================
import { media } from "./mixins";

//===============================================================================================================
// #3 - Import * Font
//===============================================================================================================
import { font } from "./font";

//===============================================================================================================
// #4 - Import * Spacements
//===============================================================================================================
import { zIndex } from "./maps";

//===============================================================================================================
// #4 - Import * Spacements
//===============================================================================================================
import { PADDING_BOTTOM_PAGE } from "./spacements";

//===============================================================================================================
// #4 - Building And Exporting The Object
//===============================================================================================================
export const base = { color, fontWeight, media, font, zIndex, PADDING_BOTTOM_PAGE };